import { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

// Si se añade/quita un tipo aquí, hay que actualizar también ABSENCE_TYPES en
// ecx-mcp/app/availability/service.py (el conector valida `type` contra esa lista;
// no es una tabla de BBDD, así que no se entera sola de los cambios aquí).
const ABSENCE_TYPES = [
    { id: "vacaciones", name: "Vacaciones" },
    { id: "baja", name: "Baja" },
    { id: "permiso", name: "Permiso" },
    { id: "otro", name: "Otro" },
];

export default function Absences(props) {
    const {
        formik,
        showWorkerBlock,
    } = props

    const [type, setType] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [observaciones, setObservaciones] = useState("");
    const [error, setError] = useState(null);

    const [absencesSelected, setAbsencesSelected] = useState([]);

    const handleAddAbsence = () => {
        setError(null);

        if (!type || !startDate || !endDate) return;

        if (endDate < startDate) {
            setError("La fecha de fin debe ser posterior o igual a la fecha de inicio");
            return;
        }

        setAbsencesSelected([...absencesSelected, { type, startDate, endDate, observaciones }]);
        setType("");
        setStartDate("");
        setEndDate("");
        setObservaciones("");
    };

    const handleRemoveAbsence = index => {
        setAbsencesSelected(absencesSelected.filter((_, i) => i !== index));
    };

    // Actualizar formik con los valores seleccionados
    useEffect(() => {
        formik.values.absences = absencesSelected;
    }, [absencesSelected]); // eslint-disable-line

    // Inicializa los valores por defecto desde formik.values.absences (al editar).
    // Depende de formik.values.id porque los datos del usuario llegan de forma
    // asíncrona (getUserApi) después del primer render del formulario.
    useEffect(() => {
        if (Array.isArray(formik.values.absences)) {
            setAbsencesSelected(formik.values.absences);
        }
    }, [formik.values.id]); // eslint-disable-line react-hooks/exhaustive-deps

    const typeName = id => ABSENCE_TYPES.find(t => t.id === id)?.name || id;

    if (!showWorkerBlock) return null;

    return (
        <Box border={1} className="p-20 mt-2 box-default">
            <Grid container spacing={3}>
                <Grid item md={6}>
                    <div style={{ gap: "10px", display: "flex", flexDirection: "column" }}>
                        <h3 className="p-0 mt-0">Ausencias y vacaciones</h3>
                        <p>
                            - Añada los periodos en los que el trabajador no está disponible.
                        </p>
                    </div>

                    <div style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}>
                        <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                            <InputLabel shrink id="absence-type-select-label">Tipo</InputLabel>
                            <Select
                                labelId="absence-type-select-label"
                                value={type}
                                onChange={e => setType(e.target.value)}
                                displayEmpty
                                label="Tipo"
                            >
                                <MenuItem value=""><em>Seleccione un tipo</em></MenuItem>
                                {ABSENCE_TYPES.map(t => (
                                    <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            label="Desde"
                            type="date"
                            size="small"
                            value={startDate}
                            onChange={e => setStartDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ mb: 1, minWidth: 150 }}
                        />
                        <TextField
                            label="Hasta"
                            type="date"
                            size="small"
                            value={endDate}
                            onChange={e => setEndDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ mb: 1, minWidth: 150 }}
                        />
                        <TextField
                            label="Observaciones"
                            size="small"
                            value={observaciones}
                            onChange={e => setObservaciones(e.target.value)}
                            fullWidth
                            sx={{ mb: 1 }}
                        />
                        <Button
                            variant="outlined"
                            onClick={handleAddAbsence}
                            disabled={!type || !startDate || !endDate}
                            sx={{ mb: 1.5 }}
                        >
                            Añadir
                        </Button>
                    </div>
                    {error && (
                        <p className="text-100 text-danger mt-1">{error}</p>
                    )}
                </Grid>
                <Grid item md={6}>
                    <div style={{ gap: "0px", display: "flex", flexDirection: "column" }}>
                        <h3 className="p-0 mt-0">&nbsp;</h3>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                            {absencesSelected.length === 0 ? (
                                <Chip label="Ninguna ausencia registrada" variant="outlined" size="small" />
                            ) : (
                                absencesSelected.map((absence, idx) => (
                                    <Chip
                                        key={idx}
                                        label={`${typeName(absence.type)}: ${absence.startDate} - ${absence.endDate}`}
                                        onDelete={() => handleRemoveAbsence(idx)}
                                        color="default"
                                        size="small"
                                        clickable
                                        variant="filled"
                                    />
                                ))
                            )}
                        </div>
                    </div>
                </Grid>
            </Grid>
        </Box>
    )
}
